import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Upload, X, Loader2 } from 'lucide-react';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

function ImageUploadField({ value, onChange, label, placeholder, testId, uploadType = 'cms' }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;
    
    setUploading(true);
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', file);
      
      // Use CMS upload endpoint for admin uploads
      const endpoint = uploadType === 'cms' 
        ? `${API}/admin/cms/upload-site-asset?asset_type=hero_image`
        : `${API}/auth/profile/image`;
      
      const res = await axios.post(endpoint, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }
      });
      onChange(res.data.url || res.data.image_url);
    } catch (err) {
      console.error('Upload failed:', err);
      // Fallback: convert to data URL for local preview
      const reader = new FileReader();
      reader.onloadend = () => onChange(reader.result);
      reader.readAsDataURL(file);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div>
      <div className="flex items-center gap-2">
        <Input
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="h-11 flex-1 font-mono text-sm"
          placeholder={placeholder || 'Image URL or upload...'}
          data-testid={testId}
        />
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="h-11 px-3 rounded-lg border border-stone-300 hover:bg-stone-50 flex items-center gap-2 text-sm text-slate-600 whitespace-nowrap"
          data-testid={`${testId}-upload-btn`}
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          Upload
        </button>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleUpload}
        />
      </div>
      {value && (
        <div className="mt-2 relative inline-block">
          <img src={value.startsWith('http') || value.startsWith('data:') ? value : `${BACKEND_URL}${value}`} alt="Preview" className="h-16 rounded-lg object-cover border" />
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
    </div>
  );
}

export default ImageUploadField;
